import React, { Component } from 'react'
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { bindActionCreators } from 'redux';
import { AC_SETTING_ROOM_HANDLE_CHANGE, AC_RESET_SETTING_ROOM, AC_EMPTY_ROOM, AC_HANDLE_ROOM_UPDATE, AC_HANDLE_MULTIROW_CLICK, AC_EMPTY_VIEWSETTING_ROOM, AC_LIST_SETTING_ROOM } from '../../actions/settingroomAction';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import ImportedURL from '../../common/api';
import { Error, Success } from '../../common/swal';
import Select from 'react-select';
import jsPDF from 'jspdf';
import Spinner from 'react-bootstrap/Spinner';
import { AC_LIST_SETTING_ROOMTYPE, AC_RESET_SETTING_ROOMTYPE } from '../../actions/settingRoomtypeAction';
import moment from 'moment';
import { Currency, SmallLetterWithoutSpace, imageCellRendererList, onErrorImage } from '../../common/validate';
import { Modal } from 'react-bootstrap';
import showSwalDialog from '../../utilities/Modal/swal';
import ErrorResponse from '../../utilities/Error/errorstatus';

const VirtualRateSymbol = [
    { name: 'If less than', symbol: '<' },
    { name: 'If less than or equal', symbol: '<=' },
    { name: 'If more than', symbol: '>' },
    { name: 'If more than or equal', symbol: '>=' },
    { name: 'If equal to', symbol: '==' },
]

const initialState = {
    modalType: "Add",
    columnDefs: [
        { headerName: '#', valueGetter: "node.rowIndex+1", width: 100, sortable: false, hide: true, filter: false, cellStyle: { 'text-align': 'center' } },
        {
            headerName: 'QR Code', field: 'uniqueqrcode', width: 120,
            cellRenderer: function (params) {
                return params.value ? `<div class="barcode-container">
                            <div class='logo_center_fix'><img src=${ImportedURL.FILEURL + params.value} class="barcode-image" alt='' width='65px' height='65px'/>
                                <div class="barcode-overlay">
                                    <a href="#" class="barcode-icon" title="Download">
                                        <i class="fa fa-download" id="downloadImage" data-action-type="Download"></i>
                                    </a>
                                </div>
                            </div>
                        </div>`: '';
            }
        },
        {
            headerName: 'Logo', width: 100, field: 'logo', sortable: false, hide: true, filter: false, "resizable": false,
            cellRenderer: imageCellRendererList,
        },
        { headerName: 'Hotel', field: 'hotelName', width: 200, hide: true, filter: false, },
        { headerName: 'Room Type', field: 'roomtype', width: 150, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
        { headerName: 'Room #', field: 'roomno', width: 120, cellStyle: { 'text-align': 'center' }, floatingFilter: true },
        { headerName: 'Floor', field: 'floor', width: 50, cellStyle: { 'text-align': 'center' }, floatingFilter: true, headerClass: 'ag-center-header', },
        {
            headerName: 'Status', width: 150, field: 'status', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true,
            cellRenderer: function (params) {
                if (params.data)
                    if (params.data.status) {
                        return `<span type="button" class="tag tag-green" data-action-type="Status">Active</span>`;
                    } else if (!params.data.status) {
                        return '<span type="button" class="tag tag-danger" data-action-type="Status">Inactive</span>';
                    }
            }
        },
        {
            headerName: 'Actions', width: 200, field: 'actions', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
            cellRenderer: function (params) {
                if (params.value) {
                    return params.value;
                }
            }
        },
    ],
    defaultColumDef: {
        editable: false,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 100,
    },
    nameError: false,
    searchhoteloption: '',
    searchhotel: '',
    id: '',
    hotelName: '',
    perPage: 25,
    selectRoomNoArray: [],
    newRoomTypeList: [],
    roomRateErrorArray: [],
    roomtypeErrorArray: [],
    roomNoErrorArray: [],
    columnreset: true,
}
class ListRoom extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }

    onRowClicked = event => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        if (value === 'View') {
            this.setState({ modalType: "View", nameError: false, id: event.data._id, });
        }
        if (value === 'Edit') {
            this.setState({ modalType: "Edit", id: event.data._id, nameError: false });
        }
        if (value === 'Service') {
            this.setState({ id: event.data._id, enddateError: false, startdateError: false, reasonError: false });
            this.props.ResetRoom()
        }
        if (value === 'Delete') {
            showSwalDialog('Are you sure you want to delete?', '', 'Ok', 'Cancel', 'assets/images/delete.png').then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.softDeleteSettingRoom + '/' + event.data._id)
                        .then((res) => {
                            Success((languageData && languageData.ROOM_SETTINGS ? languageData.ROOM_SETTINGS + " " : 'Room') + (languageData && languageData.DELETED_SUCCESSFULLY ? (languageData.DELETED_SUCCESSFULLY) : ' deleted successfully'));
                            this.setState({ searchhoteloption: '' })
                            const dataSource = this.getDataSource({ hotel: this.state.searchhotel })
                            this.gridApi.setDatasource(dataSource);
                        }).catch(({ response }) => {
                            ErrorResponse(response, languageData, 'reservation')
                        });
                }
            })
        }
        if (value === 'Status') {
            showSwalDialog('Are you sure you want to change the status?', '', 'Ok', 'Cancel', 'assets/images/status.png').then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChangeRoom, { id: event.data._id, status: !event.data.status, model: 'settingrooms' })
                        .then((data) => {
                            this.setState({ searchhoteloption: '', searchhotel: '' })
                            const dataSource = this.getDataSource({ hotel: this.state.searchhotel })
                            this.gridApi.setDatasource(dataSource);
                            Success((languageData && languageData.STATUS ? languageData.STATUS : ' Status') + (languageData && languageData.UPDATED_SUCCESSFULLY ? (languageData.UPDATED_SUCCESSFULLY) : " updated successfully"))
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                            } else if (response.status == 502) {
                                Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                            } else if (response.status == 409) {
                                Error((languageData && languageData.STATUS_ALREADY_TAGGED_WITH_DATA ? languageData.STATUS_ALREADY_TAGGED_WITH_DATA + response.data.type : "You can't be change status in this field! already tagged with " + response.data.type))
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }

    onHandleChange = e => {
        const { name, value } = e.target;
        const Error = name + "Error";
        this.setState({ [Error]: false })
        this.props.HandleInputChange(name, value);
    }



    componentDidMount() {
        this.props.EmptyRoom();
        // this.props.ListRoom();
        const account = this.props.AccountState.account;
        this.setState({ hotelName: account.hotelName ? account.hotelName : '' });
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        this.setState({ gridApi: params.api })
        this.refreshGridDataSource();
    };

    refreshGridDataSource = (params) => {
        const newDataSource = this.getDataSource(params);
        if (this.gridApi) {
            this.gridApi.setDatasource(newDataSource);
        }
        this.UpdateColumnDefs();
    };

    onPerPageChange = (newPerPage) => {
        this.setState({ perPage: newPerPage })
        this.refreshGridDataSource({ perPage: newPerPage });
    };

    UpdateColumnDefs = () => {
        const role = this.props.AccountState.role;
        if (this.gridApi && role && ImportedURL.SUPERADMIN.includes(role)) {
            let updatedColumnDefs = [...this.state.columnDefs];
            updatedColumnDefs = updatedColumnDefs.map((col) => {
                if (col.field === 'hotelName' || col.field === 'logo') {
                    return { ...col, hide: false };
                }
                return col;
            });
            this.gridApi.setColumnDefs(updatedColumnDefs);
        }
    }

    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            columnKeys: ['hotel', 'floor', 'roomno', 'roomtype'],
            fileName: 'rooms' + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    onChangeDate = e => {
        const { name, value } = e.target;
        if (name == "fromdate") {
            this.setState({ fromdate: moment(value).format("MM/DD/YYYY") });
            if (this.state.todate) {
                if (Date.parse(value) >= Date.parse(this.state.todate)) {
                    let todate = new Date(value)
                    todate.setDate(todate.getDate() + 1)
                    this.setState({ todate: todate })
                }
            }
        }
        if (name == 'todate') {
            this.setState({ todate: moment(value).format("MM/DD/YYYY") });
            if (this.state.fromdate) {
                if (Date.parse(value) <= Date.parse(this.state.fromdate)) {
                    let fromdate = new Date(value)
                    fromdate.setDate(fromdate.getDate() + 1)
                    this.setState({ fromdate: fromdate })
                }
            }
        }
    }
    DownloadPdf = () => {
        const languageData = this.props.AccountState.account.SelectedlanguageData
        this.setState({ spinner: true })
        axios.post(ImportedURL.API.listSettingRoomHistory, { fromdate: this.state.fromdate, todate: this.state.todate, hotel: this.state.searchhotel })
            .then((res) => {
                if (res.data && res.data.length > 0) {
                    const { AccountState } = this.props;
                    const account = AccountState.account;
                    var currencysymbol = ''
                    if (account.currencysymbol != undefined && account.currencysymbol != 'undefined' && account.currencysymbol && account.currencysymbol != 'null') {
                        currencysymbol = account.currencysymbol
                    }
                    var tzone = 'America/chicago'
                    if (account != undefined && account && account.tzone != undefined && account.tzone) {
                        tzone = account.tzone
                    }
                    var csVal = ''
                    if (currencysymbol) {
                        csVal = " (" + currencysymbol + ")"
                    }
                    const exportData = res.data;
                    const unit = "pt";
                    const size = "A4";
                    const orientation = "landscape";
                    const marginLeft = 15;
                    var img = new Image();
                    img.src = '../../assets/images/logo.png';
                    const doc = new jsPDF(orientation, unit, size);
                    doc.setFontSize(15);
                    const languageData = AccountState.account.SelectedlanguageData
                    let managementName = (((languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS : "Room") + ((languageData && languageData.HISTORY_MESSAGE_NAME) ? (languageData.HISTORY_MESSAGE_NAME) : ' History'))
                    const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - " + managementName : managementName) : managementName;
                    if (this.state.hotelName) {
                        var headers = [['#', "Floor", "Room #", "Room Type", "Edituser", "Status", "Enable Date", "Disable Date"]];
                        var data = exportData.map((elt, i) => [
                            i + 1,
                            elt.floor ? elt.floor : '---',
                            elt.roomno ? elt.roomno : '---',
                            elt.roomtype ? elt.roomtype : '---',
                            elt.edituserid ? (elt.edituserid + (elt.editcategoryid ? (" (" + elt.editcategoryid + ")") : '')) : "---",
                            elt.isolddatastatus ? 'Disable' : 'Enable',
                            elt.createdAt ? moment(elt.createdAt).tz(tzone).format(account.dateformate ? account.dateformate : 'MM-DD-YYYY') : '---',
                            elt.updatedAt ? moment(elt.updatedAt).tz(tzone).format(account.dateformate ? account.dateformate : 'MM-DD-YYYY') : "---",
                        ]);
                    }
                    else {
                        var headers = [['#', 'Hotel', "Floor", "Room #", "Room Type", "Edituser", "Status", "Enable Date", "Disable Date"]];
                        var data = exportData.map((elt, i) => [
                            i + 1,
                            elt.hotelName ? elt.hotelName : '---',
                            elt.floor ? elt.floor : '---',
                            elt.roomno ? elt.roomno : '---',
                            elt.roomtype ? elt.roomtype : "---",
                            elt.edituserid ? (elt.edituserid + (elt.editcategoryid ? (" (" + elt.editcategoryid + ")") : '')) : "---",
                            elt.isolddatastatus ? 'Disable' : 'Enable',
                            elt.createdAt ? moment(elt.createdAt).tz(tzone).format(account.dateformate ? account.dateformate : 'MM-DD-YYYY') : '---',
                            elt.updatedAt ? moment(elt.updatedAt).tz(tzone).format(account.dateformate ? account.dateformate : 'MM-DD-YYYY') : "---",
                        ]);
                    }
                    let content = {
                        startY: 70,
                        head: headers,
                        headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
                        body: data,
                        styles: {
                            rowHeight: 30,
                            valign: 'middle',
                            lineWidth: 0.5,
                        },
                        margin: {
                            left: 10,
                            right: 10
                        },
                        autoPaging: "text",
                    };
                    doc.addImage(img, 'png', 780, 6, 50, 50);
                    doc.setTextColor(28, 48, 120);
                    doc.text(title, marginLeft, 40);
                    doc.setTextColor(28, 48, 120);
                    // doc.text('MyHotel AI', 710, 40)
                    doc.autoTable(content);
                    var totalPages = doc.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        doc.setPage(i);
                        doc.setFontSize(11);
                        doc.setTextColor(110);
                        doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
                        doc.setFontSize(11);
                        doc.text('This is an auto-generated report from MyHotel AI (www.myhotelai.com)', 20, 575)
                    }
                    let savefile = SmallLetterWithoutSpace(managementName) + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf"
                    doc.save(savefile)
                    this.setState({ spinner: false, todate: '', fromdate: '' })
                    let btn = document.getElementById("closeModal1");
                    btn.click();
                } else {
                    Error(languageData && languageData.FULL_HISTORY_NO_RECORD_MESSAGE ? languageData.FULL_HISTORY_NO_RECORD_MESSAGE : 'No records')
                    this.setState({ spinner: false })
                }
            }).catch(({ response }) => {
                this.setState({ spinner: false })
            });
    }
    exportPDF = () => {
        const account = this.props.AccountState.account;
        const { fixNavbar, RoomState, AccountState } = this.props;
        const exportData = RoomState.listSettingRoom;
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const languageData = AccountState.account.SelectedlanguageData
        let managementName = (languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS + " List" : "Room List"
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - " + managementName : managementName) : managementName;
        if (this.state.hotelName) {
            var headers = [['#', "Floor", "Room #", "Room Type"]];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.floor,
                elt.roomno,
                elt.roomtype,
            ]);
        }
        else {
            var headers = [['#', 'Hotel', "Floor", "Room #", "Room Type"]];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.hotelName,
                elt.floor,
                elt.roomno,
                elt.roomtype,
            ]);
        }

        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hotelNameExport, 20, 545);
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hoteladdressExport, 20, 560);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("rooms" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    searchUser = e => {
        const { name, value, label } = e;
        const dataSource = this.getDataSource({ hotel: value })
        this.gridApi.setDatasource(dataSource);
        this.setState({ searchhoteloption: e, searchhotel: value, hotelName: label })
    }
    getDataSource = (query = {}) => {
        return {
            getRows: async (params) => {
                const page = Math.floor(params.startRow / this.state.perPage);
                const filter = params.filterModel;
                const sortModel = params.sortModel;
                this.props.EmptyRoom();
                await this.props.ListRoom({ hotel: this.state.searchhotel, perPage: this.state.perPage, page: page, filter: filter, sort: sortModel.length ? sortModel[0] : {}, ...query });
                const rowData = this.props.RoomState.listSettingRoom;
                const total = this.props.RoomState.total;
                const { AccountState, CountryState } = this.props;
                const account = AccountState.account;
                const previleges = AccountState.previleges;
                const Previlege = previleges.find(obj => { return obj.name == "Room_Type_And_Rooms" });
                const editOption = Previlege?.edit ? '<button type="button" class="btn btn-icon" data-action-type="Edit"><i class="fa fa-edit" style="color: #2196F3 !important" data-action-type="Edit"></i></button>' : '';
                const serviceOption = Previlege?.edit ? '<button type="button" class="btn btn-icon" data-toggle="modal" data-target="#exampleModal" data-action-type="Service"><i class="fa fa-wrench" aria-hidden="true" data-action-type="Service"></i></button>' : '';
                const deleteOption = ImportedURL.SUPERADMIN.includes(AccountState.role) ? '<button type="button" class="btn btn-icon js-sweetalert" title="Delete" data-action-type="Delete"><i class="fa fa-trash-o text-danger" style="color: red !important" data-action-type="Delete"/></button>' : '';
                const template = '<div><button type="button" class="btn btn-icon" data-action-type="View" ><i class="fa fa-eye" style="color: #1DC9B7 !important" data-action-type="View"></i></button>'
                    + serviceOption
                    + editOption
                    // + deleteOption
                    + '</div>'
                var dFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY');
                if (rowData && rowData.length > 0) {
                    rowData.forEach(object => {
                        object.actions = template;
                        object.dFormat = dFormat;
                        object.account = account;
                    });
                }
                const lbLastRowOnPageEl = document.querySelector(`[ref=\'lbLastRowOnPage\']`);
                if (lbLastRowOnPageEl) {
                    lbLastRowOnPageEl.innerHTML = (rowData) ? rowData.length + params.startRow : 0;
                }
                params.successCallback(rowData, total);
            }
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { AccountState } = this.props;
        const role = AccountState.role;
        if (this.gridApi && role && ImportedURL.SUPERADMIN.includes(role) && this.state.columnreset) {
            this.UpdateColumnDefs();
            this.setState({ columnreset: false })
        }
        if (this.gridApi) {
            if (this.props.AccountState.previleges && prevState.gridApi !== this.state.gridApi) {
                const dataSource = this.getDataSource();
                this.gridApi.setDatasource(dataSource);
            }
        }
        if (prevState.perPage !== this.state.perPage) {
            this.refreshGridDataSource();
        }
    }

    submit = e => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const data = this.props.RoomState.room;
        let isValid = true;
        if (!data.reason) {
            this.setState({ reasonError: true })
            isValid = false;
        }
        if (!data.startdate) {
            this.setState({ startdateError: true })
            isValid = false;
        }
        if (!data.enddate) {
            this.setState({ enddateError: true })
            isValid = false;
        }
        var formData = {
            outofservice: true,
            reason: data.reason,
            startdate: data.startdate,
            enddate: data.enddate,
        }
        if (isValid) {
            this.setState({ saving: true })
            axios.post(ImportedURL.API.updateSettingRoomServiceStatus + '/' + this.state.id, formData)
                .then((res) => {
                    this.setState({ saving: false })
                    Success((languageData && languageData.MOVED_TO_SERVICE ? languageData.MOVED_TO_SERVICE + " " : "  Moved to out of service") + (languageData && languageData.SUCCESSFULLY ? languageData.SUCCESSFULLY : "  successfully"));
                    this.setState({ listRedirect: true })
                    this.props.HandleInputChange('tabposition', 'rooms');
                    const dataSource = this.getDataSource()
                    this.gridApi.setDatasource(dataSource);
                    let btn = document.getElementById("closeModal");
                    btn.click();
                }).catch(({ response }) => {
                    this.setState({ saving: false })
                    if (response.status == 500) {
                        Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                    } else if (response.status == 400) {
                        Error(languageData && languageData.BAD_REQUEST ? languageData.BAD_REQUEST : 'Bad request')
                    } else if (response.status == 502) {
                        Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                    } else if (response.status == 406) {
                        Error((languageData && languageData.DOES_NOT_REMOVE_OUT_OF_SERVICE) ? languageData.DOES_NOT_REMOVE_OUT_OF_SERVICE : 'Sorry, This room have be reserved')
                    } else {
                        Error(response.statusMessage)
                    }
                });
        }
    }

    submitResssign = e => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const data = this.state.existData;
        let isValid = true;
        let roomtypeErrorArray = []
        let roomNoErrorArray = []
        let roomRateErrorArray = []
        if (data.length > 0) {
            data.map((item, i) => {
                if (!item.roomtype) {
                    roomtypeErrorArray.push(i)
                }
                if (!item.roomno) {
                    roomNoErrorArray.push(i)
                }
                if (!item.roomrate) {
                    roomRateErrorArray.push(i)
                }
            })
        }
        if (roomtypeErrorArray.length > 0) {
            this.setState({ roomtypeErrorArray })
            isValid = false
        }
        if (roomNoErrorArray.length > 0) {
            this.setState({ roomNoErrorArray })
            isValid = false
        }
        if (roomRateErrorArray.length > 0) {
            this.setState({ roomRateErrorArray })
            isValid = false
        }
        if (isValid) {
            this.setState({ saving: true })
            axios.post(ImportedURL.API.reasignRoomDataInReservation, { booking: data })
                .then((res) => {
                    this.setState({ saving: false })
                    const roomData = this.props.RoomState.room;
                    var formData = {
                        outofservice: true,
                        reason: roomData.reason,
                        startdate: roomData.startdate,
                        enddate: roomData.enddate,
                    }
                    axios.post(ImportedURL.API.updateSettingRoomServiceStatus + '/' + this.state.id, formData)
                        .then((res) => {
                            this.setState({ saving: false })
                            Success((languageData && languageData.MOVED_TO_SERVICE ? languageData.MOVED_TO_SERVICE + " " : "  Moved to out of service") + (languageData && languageData.SUCCESSFULLY ? languageData.SUCCESSFULLY : "  successfully"));
                            this.setState({ listRedirect: true })
                            this.props.HandleInputChange('tabposition', 'rooms');
                            const dataSource = this.getDataSource()
                            this.gridApi.setDatasource(dataSource);
                            this.setState({ showExitData: false })
                        }).catch(({ response }) => {
                            this.setState({ saving: false })
                            if (response.status == 500) {
                                Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                            } else if (response.status == 400) {
                                Error(languageData && languageData.BAD_REQUEST ? languageData.BAD_REQUEST : 'Bad request')
                            } else if (response.status == 502) {
                                Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                            } else if (response.status == 406) {
                                Error((languageData && languageData.DOES_NOT_REMOVE_OUT_OF_SERVICE) ? languageData.DOES_NOT_REMOVE_OUT_OF_SERVICE : 'Sorry, This room have be reserved')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }).catch(({ response }) => {
                    this.setState({ saving: false })
                });
        }
    }
    RoomNumberError = (i, type) => {
        const { roomNoErrorArray, roomtypeErrorArray, roomRateErrorArray } = this.state
        if (type == 'roomno') {
            if (roomNoErrorArray.length > 0) {
                if (roomNoErrorArray.includes(i)) {
                    return 1
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }
        if (type == 'roomtype') {
            if (roomtypeErrorArray.length > 0) {
                if (roomtypeErrorArray.includes(i)) {
                    return 1
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }
        if (type == 'roomrate') {
            if (roomRateErrorArray.length > 0) {
                if (roomRateErrorArray.includes(i)) {
                    return 1
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }
    }
    getRoomRateData = (id, formData, virtualrate, i) => {
        let startDate = formData.checkindate ? new Date(formData.checkindate) : ''
        let endDate = formData.checkoutdate ? new Date(formData.checkoutdate) : ''
        let nowDate = new Date()
        const diffInMs = endDate.getTime() - startDate.getTime();
        const diffInNows = startDate.getTime() - nowDate.getTime();
        const numberofnight = ((Math.ceil(diffInMs / (1000 * 60 * 60 * 24))) - 1)
        const numberofdays = Math.ceil(diffInNows / (1000 * 60 * 60 * 24))
        formData['mealsPriceStatus'] = true
        axios.post(ImportedURL.API.getRoomRateReservation + "/" + id, formData)
            .then((res) => {
                const data = this.state.existData;
                let RoomtypeArray = [...data]
                if (res.data != undefined) {
                    if (virtualrate) {
                        let list = []
                        let amt = 0
                        if (res.data.amountlist && res.data.amountlist.length > 0) {
                            res.data.amountlist.map((item) => {
                                let oneAmt = Number(item.rate)
                                let typeName = item.type
                                let totalAmt = 0
                                let direct = 0
                                let nights = 0
                                let days = 0
                                let occupancy = 0
                                if (virtualrate.condition.includes('direct')) {
                                    if (virtualrate.direct)
                                        if (virtualrate.directpercentages) {
                                            direct = oneAmt * (Number(virtualrate.direct) / 100)
                                        } else {
                                            if (typeName == "roomrates" || typeName == 'roomrateseasonalpricings') {
                                                direct = Number(virtualrate.direct)
                                            }
                                        }
                                }
                                if (virtualrate.condition.includes('bookingnights')) {
                                    if (virtualrate.bookingnights && virtualrate.bookingnights.length > 0) {
                                        let bookingnightsStatus = false
                                        virtualrate.bookingnights.map((item) => {
                                            if (item.operation && item.nights && item.price && !bookingnightsStatus) {
                                                let sym = VirtualRateSymbol.find(i => i.name == item.operation)
                                                let value1 = Number(numberofnight)
                                                let value2 = Number(item.nights)
                                                const condition = eval(`${value1} ${sym.symbol} ${value2}`);
                                                if (condition) {
                                                    if (item.percentagestatus) {
                                                        nights = nights + (oneAmt * (Number(item.price) / 100))
                                                    } else {
                                                        if (typeName == "roomrates" || typeName == 'roomrateseasonalpricings') {
                                                            nights = Number(item.price)
                                                        }
                                                    }
                                                    bookingnightsStatus = true
                                                }
                                            }
                                        })
                                    }
                                }
                                if (virtualrate.condition.includes('daysbeforearrival')) {
                                    if (virtualrate.daysbeforearrival && virtualrate.daysbeforearrival.length > 0) {
                                        let daysbeforearrivalStatus = false
                                        virtualrate.daysbeforearrival.map((item) => {
                                            if (item.operation && item.days && item.price && !daysbeforearrivalStatus) {
                                                let sym = VirtualRateSymbol.find(i => i.name == item.operation)
                                                let value1 = Number(numberofdays)
                                                let value2 = Number(item.days)
                                                const condition = eval(`${value1} ${sym.symbol} ${value2}`);
                                                if (condition) {
                                                    if (item.percentagestatus) {
                                                        days = days + (oneAmt * (Number(item.price) / 100))
                                                    } else {
                                                        if (typeName == "roomrates" || typeName == 'roomrateseasonalpricings') {
                                                            days = Number(item.price)
                                                        }
                                                    }
                                                    daysbeforearrivalStatus = true
                                                }
                                            }
                                        })
                                    }
                                }
                                list.push({
                                    startDate: item.startDate,
                                    endDate: item.endDate,
                                    id: item.id,
                                    type: (typeName == "roomrates" || typeName == 'roomrateseasonalpricings') ? 'roomratevirtuals' : item.type,
                                    rate: oneAmt + direct + nights + days + occupancy
                                })
                                amt += (oneAmt + direct + nights + days + occupancy)
                            })
                        }
                        RoomtypeArray = [
                            ...RoomtypeArray.slice(0, i),
                            { ...RoomtypeArray[i], ['totalamount']: amt, ['amountlist']: list, ['virtualroomrate']: virtualrate._id, ['roomrate']: '', },
                            ...RoomtypeArray.slice(i + 1)
                        ]
                    } else {
                        RoomtypeArray = [
                            ...RoomtypeArray.slice(0, i),
                            { ...RoomtypeArray[i], ['totalamount']: res.data.totalamount, ['amountlist']: res.data.amountlist, ['virtualroomrate']: '', ['roomrate']: id, },
                            ...RoomtypeArray.slice(i + 1)
                        ]
                        this.setState({ existData: RoomtypeArray })
                    }
                }
            }).catch(({ response }) => {
                console.log(response)
            });
    }

    onChangeItemSelectArray = (i, e) => {
        const { name, value } = e
        const data = this.state.existData;
        let RoomtypeArray = [...data]
        if (name == 'roomtype') {
            let roomtypeErrorArray = this.state.roomtypeErrorArray.filter((item, index) => item !== i)
            this.setState({ roomtypeErrorArray: roomtypeErrorArray })
            RoomtypeArray = [
                ...RoomtypeArray.slice(0, i),
                { ...RoomtypeArray[i], [name]: value, ['roomrate']: '', ['totalamount']: '0' },
                ...RoomtypeArray.slice(i + 1)
            ]
            this.setState({ existData: RoomtypeArray })
        } else {
            RoomtypeArray = [
                ...RoomtypeArray.slice(0, i),
                { ...RoomtypeArray[i], [name]: value },
                ...RoomtypeArray.slice(i + 1)
            ]
            this.setState({ existData: RoomtypeArray })
        }
        if (name == 'roomno') {
            let roomNoErrorArray = this.state.roomNoErrorArray.filter((item, index) => item !== i)
            this.setState({ roomNoErrorArray: roomNoErrorArray })
            let index = this.state.selectRoomNoArray.findIndex((e) => e.index == i)
            if (index != -1) {
                let selectRoomNoArray = this.state.selectRoomNoArray
                selectRoomNoArray = [
                    ...RoomtypeArray.slice(0, index),
                    { ...RoomtypeArray[index], ["id"]: value },
                    ...RoomtypeArray.slice(index + 1)
                ]
                this.setState({ selectRoomNoArray: selectRoomNoArray })
            } else {
                this.setState({ selectRoomNoArray: [...this.state.selectRoomNoArray, { index: i, id: value }] })
            }
        }
        if (name == 'roomrate') {
            let roomRateErrorArray = this.state.roomRateErrorArray.filter((item, index) => item !== i)
            this.setState({ roomRateErrorArray: roomRateErrorArray })
            let dataIndex = RoomtypeArray.find((e, index) => index == i)
            let formData = {
                checkindate: moment(dataIndex.checkindate).format("MM-DD-YYYY"),
                checkoutdate: moment(dataIndex.checkoutdate).format("MM-DD-YYYY"),
                adult: dataIndex.adult,
                children: dataIndex.children,
                roomrate: value,
                roomtype: dataIndex.roomtype,
            }
            this.getRoomRateData(value, formData, null, i)
        }
    }
    render() {
        if (this.state.modalType === "View") return <Redirect to={'/view-setting-room/' + this.state.id} />
        if (this.state.modalType === "Edit") return <Redirect to={'/edit-setting-room/' + this.state.id} />

        const { SettingRoomtypeState, RoomState, AccountState, HotelState } = this.props;
        const listHotels = HotelState.listhotels;
        const rowData = RoomState.listSettingRoom;
        const spinner = RoomState.spinner;
        const Roomtype = SettingRoomtypeState.listSettingRoomtype;
        const listRoomRate = []

        const account = AccountState.account;
        const languageData = AccountState.account.SelectedlanguageData
        const previleges = AccountState.previleges;
        const Previlege = previleges.find(obj => { return obj.name == "Room_Type_And_Rooms" });
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        var hotelOptionSearch = [];
        if (listHotels.length > 1) {
            hotelOptionSearch.push({ label: 'All', value: '', name: 'searchhotel' })
        }
        if (listHotels.length > 0) {
            listHotels.filter(filterItem => filterItem.status === true).map(item => {
                hotelOptionSearch.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'searchhotel' });
            })
        }
        const data = this.props.RoomState.room;
        var currency = (account.currencysymbol != undefined && account.currencysymbol != 'undefined' && account.currencysymbol) ? account.currencysymbol : ''

        var dFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY');
        var tFormat = (account.timeformat != '' ? account.timeformat : "hh:mm A");

        return (
            <>
                <div>
                    <div>
                        <div className="container-fluid">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className='rounded_icon'><i className="icon-home mr-2 "></i></div>
                                            <h3 className="card-title"> {(languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS + " List" : "Room List"}</h3>
                                            <div className="card-options">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <ul className="nav nav-tabs page-header-tab">
                                                    </ul>
                                                    <div className="header-action">
                                                        {Previlege?.add ? <Link to='/add-setting-multipleroom'><button type="button" className="multiple" data-toggle="modal" data-target="#exampleModal" onClick={(e) => this.props.ResetRoom()} id='Add'><i className="fe fe-plus mr-2" id='Add' />Multiple Rooms</button></Link> : ''}
                                                        {Previlege?.add ? <Link to='/addsetting-room'><button type="button" className="btn btn-primary mr-3" data-toggle="modal" data-target="#exampleModal" onClick={(e) => this.props.ResetRoom()} id='Add'><i className="fe fe-plus mr-2" id='Add' />Add</button></Link> : ''}
                                                    </div>
                                                </div>
                                                {rowData && rowData.length > 0 ? <>
                                                    <a className="btn btn-primary btn-sm nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                        <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                        {/* <a className="dropdown-item" type='button' data-toggle="modal" data-target="#exampleModal1"><i className="dropdown-icon fa fa-history"></i> History</a> */}
                                                    </div>
                                                </> : []}
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xl-3">
                                                    <label className="form-label">Limit</label>
                                                    <div className="form-group">
                                                        <Select
                                                            onChange={(e) => this.onPerPageChange(Number(e.value))}
                                                            options={limitOptions}
                                                            defaultValue={limitOptions[0]}
                                                            className='limit_size'
                                                        />
                                                    </div>
                                                </div>
                                                {
                                                    account?.allhotels == undefined &&
                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-xl-6">
                                                        <label className="form-label">{languageData && languageData.SEARCH ? languageData.SEARCH : "Search"} {languageData && languageData.HOTEL ? languageData.HOTEL : "Hotel"}</label>
                                                        <div className="form-group" style={{ marginBottom: '10px' }}>
                                                            <Select
                                                                value={this.state.searchhoteloption}
                                                                onChange={this.searchUser}
                                                                options={hotelOptionSearch}
                                                                formatOptionLabel={(e) => (
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        {e.label != 'All' && <img className='all_search_image_size contain_image' src={ImportedURL.FILEURL + e.logo} onError={onErrorImage} />}
                                                                        <div style={e.label != 'All' ? { paddingLeft: '10px' } : {}}><span className='all_search_text_size' >{e.label}</span></div>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="table-responsive">
                                                <div className={(rowData && rowData.length == 0) ? "ag-theme-alpine ag_grid_no_record_show" : "ag-theme-alpine"}>
                                                    <AgGridReact
                                                        key={this.state.perPage}
                                                        rowHeight={82}
                                                        paginationPageSize={this.state.perPage}
                                                        cacheBlockSize={this.state.perPage}
                                                        pagination={true}
                                                        onRowClicked={this.onRowClicked}
                                                        domLayout={"autoHeight"}
                                                        defaultColDef={this.state.defaultColumDef}
                                                        // rowData={rowData}
                                                        onGridReady={this.onGridReady}
                                                        columnDefs={this.state.columnDefs}
                                                        rowDragManaged={true}
                                                        wrapText={true}
                                                        animateRows={true}
                                                        overlayNoRowsTemplate={"No rows to display"}
                                                        rowModelType={'infinite'}
                                                    >
                                                    </AgGridReact>
                                                </div>
                                                {
                                                    (rowData && rowData.length == 0)
                                                    &&
                                                    <span className='ag_grid_no_record_show_span' >No rows to display</span>
                                                }
                                                {/* <div id="overlay" style={{ display: spinner ? 'block' : 'none' }}></div> */}
                                                {spinner ?
                                                    <div className='common_loader_ag_grid'>
                                                        <img className='loader_img_style_common_ag_grid' src='../../assets/images/load.png' />
                                                        <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                        </Spinner>
                                                    </div>
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Modal */}
                        <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <div className='rounded_icon'><i class="fa fa-wrench" aria-hidden="true" data-action-type="Service"></i></div>
                                        <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '5px' }}> {languageData && languageData.OUT_OF_SERVICE ? languageData.OUT_OF_SERVICE : "Out Of Service"}</h5>
                                        <button type="button" id="closeModal" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true" style={{ fontSize: "23px" }}>
                                                <img src='../../assets/images/cancel.png' />
                                            </span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row clearfix">
                                            <div className="col-md-12 mb-0">
                                                <div className="form-group mb-0">
                                                    <label className="form-label">Reason for service<span className="ml-1" style={{ color: 'red' }}>*</span></label>
                                                    <textarea className="form-control" name="reason" placeholder="Reason for service" value={data.reason} rows="4" cols="50" onChange={this.onHandleChange} />
                                                    <div className='d-flex justify-content-end'>
                                                        <div className="invalid-feedback" style={{ display: this.state.reasonError ? "block" : 'none' }}>Reason for service is required</div>
                                                        <p className='mt-1' style={{ width: "75px", textAlign: "right" }}><span>{data.reason ? data.reason.length : 0}</span>/ <span>255</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0 pr-0">
                                            <div className="form-group">
                                                <label className="form-label">Start Date<span className="ml-1" style={{ color: 'red' }}>*</span></label>
                                                <div className='site_pass_calander'>
                                                    <input type="date" className="form-control" max={data.enddate} value={data.startdate} name="startdate" onChange={this.onHandleChange} />
                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                    <div className="invalid-feedback" style={{ display: this.state.startdateError ? "block" : 'none' }}>Start Date is required</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 pl-0 pr-0">
                                            <div className="form-group">
                                                <label className="form-label">End Date<span className="ml-1" style={{ color: 'red' }}>*</span></label>
                                                <div className='site_pass_calander'>
                                                    <input type="date" className="form-control" min={new Date().toISOString().split('T')[0]} value={data.enddate} name="enddate" onChange={this.onHandleChange} />
                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                    <div className="invalid-feedback" style={{ display: this.state.enddateError ? "block" : 'none' }}>End Date is required</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer text-right mandatory">
                                        <label className="form-label text-left mandatory-label"><span className="mr-1" style={{ color: 'red' }}>*</span>Mandatory Fields </label>
                                        <div className="" >
                                            {
                                                this.state.saving ?
                                                    <button type="button" className="btn commor_save " ><i className="fa fa-spinner fa-spin mr-2"></i>Saving</button>
                                                    :
                                                    <button type="button" className="btn commor_save" onClick={this.submit}><i className="fe fe-save mr-2"></i>Save</button>
                                            }
                                            <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} data-dismiss="modal"><i className="fa fa-times mr-2"></i>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade country_model" id="exampleModal1" autoComplete="off" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className='rounded_icon'><i className="icon-home mr-2 "></i></div>
                                    <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '5px' }}>{((languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS : "Room") + ((languageData && languageData.HISTORY_MESSAGE_NAME) ? (languageData.HISTORY_MESSAGE_NAME) : ' History')}</h5>
                                    <button type="button" id="closeModal1" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" style={{ fontSize: "23px" }}>
                                            <img src='../../assets/images/cancel.png' />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-6">
                                            <label className="form-label">From Date</label>
                                            <div className="form-group">
                                                <div className='site_pass_calander'>
                                                    <input type="date" value={this.state.fromdate ? moment(this.state.fromdate).format('YYYY-MM-DD') : ''} className="form-control" name="fromdate" onChange={this.onChangeDate} />
                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-6">
                                            <label className="form-label">To Date</label>
                                            <div className="form-group" >
                                                <div className='site_pass_calander'>
                                                    <input type="date" value={this.state.todate ? moment(this.state.todate).format('YYYY-MM-DD') : ''} className="form-control" name="todate" onChange={this.onChangeDate} />
                                                    <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button type="button" className="btn commor_save" style={{ fontSize: '14px' }} onClick={this.DownloadPdf} ><i className="fa fa-file-pdf-o mr-2"></i>PDF Download</button>
                                    <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} data-dismiss="modal"><i className="fa fa-times mr-2"></i>Close</button>
                                </div>
                                <div id='overlay-model' style={{ display: this.state.spinner ? 'block' : 'none' }}></div>
                                {this.state.spinner ?
                                    <div className='model_loader_poss'>
                                        <img className='loader_img_style_model' src='../../assets/images/load.png' />
                                        <Spinner className='spinner_load_model' animation="border" variant="info" >
                                        </Spinner>
                                    </div>
                                    : ''}
                            </div>
                        </div>
                    </div>

                    {/* ----------------------------------  Already reserved  ----------------------------------- */}

                    <Modal className={'info-modal'} show={this.state.showExitData} onHide={(e) => this.setState({ showExitData: false })} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: '18px' }}>{"REASSIGN ROOM"}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="Over_all_table_style col-sm-12 col-md-12">
                                {
                                    (this.state.existData && this.state.existData.length > 0)
                                        ?
                                        <>
                                            <table class="table table-borderless booking_tables">
                                                <thead>
                                                    <tr style={{ textAlign: "center" }}>
                                                        <th>Guest Name</th>
                                                        <th >Dates</th>
                                                        <th >Room Type<span className="ml-1" style={{ color: 'red' }}>*</span></th>
                                                        <th >Room #<span className="ml-1" style={{ color: 'red' }}>*</span></th>
                                                        <th >Room rate<span className="ml-1" style={{ color: 'red' }}>*</span></th>
                                                        <th style={{ width: '110px' }}>Price</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.existData.map((item, i) => {

                                                            let roomtypeSelect = ''
                                                            let roomtypeOption = []
                                                            if (Roomtype && Roomtype.length > 0) {
                                                                Roomtype.map((type) => {
                                                                    if (type._id == item.roomtype) {
                                                                        roomtypeSelect = { label: type.roomname, value: type._id, name: 'roomtype' }
                                                                    }
                                                                    roomtypeOption.push({ label: type.roomname, value: type._id, name: 'roomtype' })
                                                                })
                                                            }
                                                            let roomrateOption = []
                                                            let roomrateValue = ''
                                                            if (listRoomRate && listRoomRate.length > 0) {
                                                                listRoomRate.filter(e => e.status === true).map((item1) => {
                                                                    let status = item1.roomrate.find((e) => e.roomtype == item.roomtype)
                                                                    if (status) {
                                                                        if (item.roomrate == item1._id) {
                                                                            roomrateValue = { label: item1.name, value: item1._id, name: "roomrate" }
                                                                        }
                                                                        roomrateOption.push({ label: item1.name, value: item1._id, name: "roomrate" })
                                                                    }
                                                                })
                                                            }
                                                            let roomtypeStatus = true;
                                                            let roomrateStatus = true;
                                                            var selectroomNo = '';
                                                            let roomnoList = [];
                                                            let roomNumberList = this.state.newRoomTypeList[i]
                                                            roomNumberList && roomNumberList.map(item1 => {
                                                                if (item1.roomtypeId == item.roomtype) {
                                                                    if (item1._id == item.roomno) {
                                                                        selectroomNo = { label: item1.roomno, value: item1._id, name: 'roomno', }
                                                                    }
                                                                    roomnoList.push({ label: item1.roomno, value: item1._id, name: 'roomno', })
                                                                    // let status = this.state.selectRoomNoArray.find((e) => (e.id == item1._id && e.index != i))
                                                                    // if (!status) {
                                                                    // roomnoList.push({ label: item1.roomno, value: item1._id, name: 'roomno', })
                                                                    // }
                                                                }
                                                            })
                                                            if (roomnoList.length == 0) {
                                                                roomtypeStatus = false
                                                                roomrateStatus = false
                                                            }
                                                            if (!item.roomrate) {
                                                                roomrateStatus = false
                                                            }
                                                            return (
                                                                <>
                                                                    <tr className='reservation_arrangement'>
                                                                        <td>
                                                                            <div className="form-group" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                <p style={{ marginBottom: '0px' }}>
                                                                                    {item.firstname + ' ' + item.lastname}
                                                                                </p>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                <p className='mb-0'>{moment(item.checkindate).format(dFormat) + "  -  " + moment(item.checkoutdate).format(dFormat)}</p>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                roomtypeStatus
                                                                                    ?
                                                                                    <div className="form-group " style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                        <p style={{ marginBottom: '0px' }}>
                                                                                            {roomtypeSelect ? roomtypeSelect.label : '---'}
                                                                                        </p>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="form-group alignment_div">
                                                                                        <Select
                                                                                            value={roomtypeSelect}
                                                                                            onChange={e => this.onChangeItemSelectArray(i, e, item)}
                                                                                            options={roomtypeOption}
                                                                                        />
                                                                                        <div className="invalid-feedback" style={{ display: this.RoomNumberError(i, "roomtype") ? "block" : 'none' }}>Room Type is required</div>
                                                                                    </div>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group alignment_div">
                                                                                <Select
                                                                                    value={selectroomNo}
                                                                                    onChange={e => this.onChangeItemSelectArray(i, e, item)}
                                                                                    options={roomnoList}
                                                                                />
                                                                                <div className="invalid-feedback" style={{ display: this.RoomNumberError(i, "roomno") ? "block" : 'none' }}>Room # is required</div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                roomrateStatus
                                                                                    ?
                                                                                    <div className="form-group" style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                        <p style={{ marginBottom: '0px' }}>
                                                                                            {roomrateValue ? roomrateValue.label : '---'}
                                                                                        </p>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="form-group alignment_div">
                                                                                        <Select
                                                                                            value={roomrateValue}
                                                                                            onChange={e => this.onChangeItemSelectArray(i, e, item)}
                                                                                            options={roomrateOption}
                                                                                        />
                                                                                        <div className="invalid-feedback" style={{ display: this.RoomNumberError(i, "roomrate") ? "block" : 'none' }}>Room Rate is required</div>
                                                                                    </div>
                                                                            }
                                                                        </td>
                                                                        <td >
                                                                            <div className="form-group">
                                                                                <p style={{ marginBottom: '0px', display: 'flex', justifyContent: 'center' }}>
                                                                                    {item.totalamount ? currency + ' ' + Currency(item.totalamount) : '0'}
                                                                                </p>
                                                                            </div>
                                                                        </td>
                                                                    </tr >
                                                                </>
                                                            )
                                                        })
                                                    }

                                                </tbody>
                                            </table>
                                        </>
                                        :
                                        <>
                                            <div className="card-body no_records text-center d-flex align-items-center justify-content-center pt-0">
                                                <div style={{ maxWidth: "340px" }}>
                                                    <img src="../assets/images/nothing-here.png" alt="..." className="img-fluid" style={{ maxWidth: "272px" }} />
                                                    <h5 className="mb-2">No records to display </h5>
                                                </div>
                                            </div>
                                        </>
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <label className="form-label text-left mandatory-label"><span className="mr-1" style={{ color: 'red' }}>*</span>Mandatory Fields </label>
                            </div>
                            <div >
                                {
                                    this.state.saving ?
                                        <button type="button" className="btn commor_save" ><i className="fa fa-spinner fa-spin mr-2"></i>{this.state.modalType == "Edit" ? "Updating" : "Saving"}</button>
                                        :
                                        <button type="button" className="btn commor_save" onClick={this.submitResssign}><i className="fe fe-save mr-2"></i>{this.state.modalType == "Edit" ? "Update" : "Save"}</button>
                                }
                                <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} onClick={(e) => this.setState({ showExitData: false })}><i className="fa fa-times mr-2"></i>Close</button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                </div >
            </>
        )
    }
}
const mapStateToProps = state => ({
    HotelState: state.hotel,
    AccountState: state.account,
    RoomState: state.settingroom,
    RoomareaAmenityState: state.roomareaamenity,
    SettingRoomtypeState: state.settingroomtype,
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ListRoom: AC_LIST_SETTING_ROOM,
        HandleInputChange: AC_SETTING_ROOM_HANDLE_CHANGE,
        ResetRoom: AC_RESET_SETTING_ROOM,
        AC_HANDLE_ROOM_UPDATE,
        AC_HANDLE_MULTIROW_CLICK,
        EmptyRoom: AC_EMPTY_ROOM,
        ResetRoomtype: AC_RESET_SETTING_ROOMTYPE,
        ListRoomType: AC_LIST_SETTING_ROOMTYPE,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListRoom);